import { configureStore } from "@reduxjs/toolkit";
import { routerMiddleware } from "react-router-redux";
import logger from "redux-logger";

import rootReducer from "../reducers";

import { baseApi } from "./baseApi";

export function configStore(history, preloadedState) {
  const isDev =
    "test" === process.env.NODE_ENV || "development" === process.env.NODE_ENV;

  const middleware = (getDefaultMiddleware) => {
    const base = getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: true,
    }).concat(routerMiddleware(history), baseApi.middleware);

    return isDev ? base.concat(logger) : base;
  };

  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware,
    devTools: isDev,
  });
}
